import type { BootstrapableForm } from "types"
import type { useForm } from "hooks";
import type { IbanXsBanksRecipientsPivot } from "features/openBanking/types";
import { RecipientsPivotFormField } from "../shared";

export const FormField = {
    ...RecipientsPivotFormField,
    Iso2: 'iso2'
} as const;

export type IbanXSBanksRecipientsPivot = {
    readonly [FormField.Iso2]: Array<string>;
} & Pick<
    IbanXsBanksRecipientsPivot,
    | 'bankId'
    | 'recipientId'
    | 'MOR'
    | 'isEnabled'
>;

export type IbanXSBanksRecipientsPivotForm = Omit<BootstrapableForm<IbanXSBanksRecipientsPivot, {}>, 'initialValues'> & {
    readonly initialValues: IbanXSBanksRecipientsPivot;
    readonly enableReinitialize?: boolean;
};

export type IbanXSBanksRecipientsPivotProps =
    & IbanXSBanksRecipientsPivotForm
    & ReturnType<typeof useForm<IbanXSBanksRecipientsPivot>>;
